import { render, staticRenderFns } from "./accolist_button.vue?vue&type=template&id=2461b48a&scoped=true"
import script from "./accolist_button.vue?vue&type=script&lang=js"
export * from "./accolist_button.vue?vue&type=script&lang=js"
import style0 from "./accolist_button.vue?vue&type=style&index=0&id=2461b48a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2461b48a",
  null
  
)

export default component.exports